import Introduction from "./introduction.mdx"
import Introductio_ar from "./introduction_ar.mdx"
import { useLang } from "hooks/useLang"
import FadeOutEffect from "components/atoms/FadeOutEffect"

const IntroductionComponent = () => {
    const { lang } = useLang()
    const renderIntro = lang === "ar" ? <Introductio_ar /> : <Introduction />


    return (
        <FadeOutEffect fadeStartAt={200} fadeHeight={50}>
            <div className="max-w-2xl">

                <div style={{
                    fontWeight: 300
                }} id="event-description">
                    {renderIntro}
                </div>

            </div>
        </FadeOutEffect>
    )
}

export default IntroductionComponent




